//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            residents: [],
            headers: ['Name', {
                title: 'Move Out',
                filter: 'dateFull'
            }],
            fields: ['person.full_name', 'move_out_date']
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('show-move-out-alerts', function () {
            return _this.getMoveoutAlerts();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('show-move-out-alerts');
    },
    mounted: function mounted() {
        this.getMoveoutAlerts();
    },

    methods: {
        getMoveoutAlerts: function getMoveoutAlerts() {
            var _this2 = this;

            axios.get('/prototype/properties/showMoveOutAlerts').then(function (response) {
                _this2.residents = response.data;
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/dashboard/MoveOutAlerts.vue
// module id = f8RX
// module chunks = 0 1